module.exports = __webpack_public_path__ + "assets/not-fount.9d4be817.svg";